import { useState , useEffect } from 'react'
import { useStore } from 'store'
import { hideLoader, showLoader } from 'store/actions/commons'
import barcodeSecond2 from 'assets/img/scanToStore.svg';
import useLinnkToBarcode from 'newHooks/useLinnkToBarcode';
import ProductsResp from 'newComponents/ProductsModal/ProductResponse';
import ProductsSuccessAdd from 'newComponents/ProductsModal/ProductSuccessAdd';
import useAddProductStore from 'newHooks/useAddProductStore';
import ModalQR from '../Modal'
import Html5QrcodePlugin from './camara'
import styles from './styles.module.sass'


const BarCodeScan = () => {
    
    const [ , dispatch ] = useStore((state) => state.giftTable.giftTable)
    const {
        handleSKU,
        setResetResponse,
        responseProduct,
        responseError
    } = useLinnkToBarcode()

    const {
        handleStoreSKU,
        setResetResponseStore,
        responseProductStore,
        responseErrorStore
    } = useAddProductStore()

    const [errorProduct, setErrorProduct] = useState(false)
    const [ toggleModal, setToggleModal ] = useState(false)
    const [ updateScanner, setUpdateScanner ] = useState(null)
    const [ valSKU, setValSKU ] = useState('')
    const [ showModal, setShowModal ] = useState(false)
    const isMobile = 'desktop'
    const title = 'Agrega productos con tu celular.'


    const handleClick = () => {
        setToggleModal(true)
    }

    const handleClose = () => {
        setToggleModal(false)
    }

    const handleChange = (e) => {
        const sku = e.target.value
        setValSKU(sku)
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        if(String(valSKU).length >= 3){
            setToggleModal(false)
            dispatch(showLoader());
            handleSKU(valSKU)
        }
    }

    const resettUrl = () => {
        setValSKU('')
        dispatch(hideLoader())
        setErrorProduct(false)
        setResetResponseStore()
        setResetResponse()
    }

    useEffect(()=>{
        if(responseProduct){
            dispatch(hideLoader());
            setShowModal(true)
        }else if(responseError){
            handleStoreSKU(valSKU)
        }
    },[responseProduct, responseError])

    useEffect(()=>{
        if(responseProductStore){
            dispatch(hideLoader())
            setErrorProduct(true)
        }
    },[responseProductStore, responseErrorStore])

    useEffect(()=>{
        if(updateScanner){
            setToggleModal(false)
            dispatch(showLoader());
            handleSKU(updateScanner)
            setUpdateScanner(null)
        }
    },[updateScanner])

    return (
        <>
            <div className={styles?.qrPrimary2} onClick={handleClick}  aria-hidden>
                <img src={barcodeSecond2} alt="Imprimir código QR" />
                <div className={styles?.contTitles}>
                    <div className={styles?.title}>Agrega productos con tu celular.</div>
                    <div className={styles?.linkRed}>Escanear</div>
                </div>
            </div>

            {toggleModal
                ?
                    <ModalQR
                        onClose={handleClose} 
                        isMobile={isMobile} 
                        type={isMobile === 'desktop' ? '' : 'full'} 
                        title={title} 
                        closeBody="modalPromos"
                    >
                        <div>
                            <div onClick={handleClose} className={styles?.closeBtn} aria-hidden >X</div>
                            <h3 className={styles.title}>Escanear productos</h3>
                            <p>Escanear código de barras para buscar productos de forma rápida y sencilla</p>
                            <div>
                                <Html5QrcodePlugin
                                    fps={20}
                                    qrbox={250}
                                    aspectRatio={4/3}
                                    disableFlip={false}
                                    qrCodeSuccessCallback={setUpdateScanner}
                                />
                            </div>

                            <p className={styles?.textCenter}>
                                <strong>Ingresar código manualmente</strong>
                            </p>
                            <div className="d-flex flex-column align-items-center">
                                <form className={styles?.formBarCode} onSubmit={handleSubmit}>
                                    <input 
                                        name="search" 
                                        id="search" 
                                        placeholder="Ingresa el código sku" 
                                        maxLength="100" 
                                        type="text" 
                                        className={styles?.inputBarCode} 
                                        onChange={handleChange} 
                                        value={valSKU}  
                                    />
                                    <button type="submit" className="btn btn-primary">Buscar</button>
                                </form>
                            </div>
                        </div>
                    </ModalQR >
                : null
            }
            {responseProduct?.length >= 1
                ? <ProductsResp item={responseProduct[0]} showModal={showModal} resettUrl={resettUrl} />
                : null 
            }
            {errorProduct
                ?
                    <ProductsSuccessAdd
                        successStore={errorProduct}
                        setSuccessStore={setErrorProduct}
                        resettUrl={resettUrl}
                    />
                : null
            }
        </>
    )
}


export default BarCodeScan